import React, { Component } from 'react';

import ReduxConnect from 'Demora/redux-connect';

import { withRouter } from 'react-router-dom';

import socialHttp from '../../../../utils/socialHttp';

import UploadProfileImage from './UploadProfileImage';

import DMForm from 'Demora/DMForm';

import confirm from 'Demora/modals/confirm';

import http from 'Demora/http';

import GroupEditAdmins from './GroupEditAdmins';

import modal from 'Demora/modals/modal';

import classnames from 'classnames';

import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';

class GroupSettingsModal extends Component {
	constructor() {
		super();

		this.state = {
			deletingGroup: false,
			activeTab: 0,
		};
	}

	saveSettings = (d) => {
		let props = this.props;

		socialHttp('put', '/data/groups/' + props.obj, {
			name: d.name,
			header: d.header,
			private: d.private,
		})
			.then((data) => {
				let obj = props.obj;

				let feed = props.feed;

				feed[obj].header = d.header;

				this.props.dispatch({
					type: 'STORE_FEED',
					data: {
						feed: feed,
					},
				});

				modal.close('edit_group');
			})
			.catch((e) => {
				throw e;
			});
	};

	saveImage = (images) => {
		socialHttp('put', '/data/groups/' + this.props.obj, {
			images: images,
		})
			.then((data) => {
				modal.close('edit_group');
			})
			.catch((e) => {
				throw e;
			});
	};

	deleteGroup = () => {
		let props = this.props;

		confirm({
			id: 'deleteGroup',
			header: 'Delete Group',
			message:
				'Are you sure you want to delete the group ' +
				props.users[props.obj].first_name +
				' ' +
				props.users[props.obj].last_name +
				'?',
			confirmButtonText: 'Yes',
			confirmFunc: this.processDeleteGroup,
		});
	};

	processDeleteGroup = () => {
		if (this.state.deletingGroup) {
			return;
		}

		this.setState({
			deletingGroup: true,
		});

		let obj = this.props.obj;

		http
			.delete('/data/groups/deleteGroup/' + obj)
			.then((data) => {
				this.removeGroupFromRedux();

				modal.close('deleteGroup');
			})
			.catch((e) => {
				throw e;
			});
	};

	removeGroupFromRedux() {
		let props = this.props;

		let obj = props.obj;

		let f = { feed: {} };

		f.feed[obj] = [];

		this.props.dispatch({
			type: 'STORE_FEED',
			data: f,
		});

		f.feed[obj] = {};

		this.props.dispatch({
			type: 'STORE_FEED',
			data: f,
		});

		props.history.push('/home');
	}

	toggle(tab) {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab,
			});
		}
	}

	render() {
		let state = this.state;

		let props = this.props;

		let obj = props.obj;

		let feed = props.feed[obj];

		let form = {
			fields: [
				{
					name: 'name',
					label: 'Name of your group',
					placeHolder: 'Name',
					inputType: 'text',
					dataType: 'string',
					helpMessage: 'The name of your group',
					disabled: false,
					maxLength: 40,
					value: props.users[obj].first_name,
					required: true,
				},
				{
					name: 'header',
					label: 'Header text',
					placeHolder: 'Name',
					inputType: 'textarea',
					dataType: 'string',
					helpMessage: 'The text that appears at the top of the group.',
					disabled: false,
					maxLength: 225,
					value: feed.header,
					required: false,
				},
				{
					name: 'private',
					label: 'Is this group private?',
					placeHolder: '',
					inputType: 'checkbox',
					dataType: 'boolean',
					helpMessage: '',
					value: !!feed.private,
				},
			],
			button: {
				text: 'Save',
				class: 'btn-primary',
				position: 'right',
			},
			labelsAboveFields: true,
			submit: this.saveSettings,
			clearFormAfterSubmit: true,
		};

		form.inModal = true;

		form.closeButton = () => {
			modal.close(edit_group);
		};

		let user = props.users[obj];

		let tabs = ['Info', 'Image'];

		let creator = feed.creator == props.user.id;

		if (creator) {
			tabs.push('Admins');
			tabs.push('Delete');
		}

		return (
			<div>
				<Nav tabs>
					{tabs.map((v, k) => {
						return (
							<NavItem key={k}>
								<NavLink
									className={classnames({ active: state.activeTab === k })}
									onClick={() => {
										this.toggle(k);
									}}
								>
									{v}
								</NavLink>
							</NavItem>
						);
					})}
				</Nav>

				<TabContent
					activeTab={state.activeTab}
					style={{ margin: '20px 0 100px 0' }}
				>
					<TabPane tabId={0}>
						<DMForm form={form} />
					</TabPane>
					<TabPane tabId={1}>
						<h4>Profile Picture</h4>
						<UploadProfileImage
							returnImages={this.saveImage}
							image={user.image}
							singleImage={true}
						/>
					</TabPane>

					{creator && (
						<TabPane tabId={2}>
							<h4>Select Group Admins</h4>,
							<GroupEditAdmins obj={obj} />
						</TabPane>
					)}

					{creator && (
						<TabPane tabId={3}>
							<h4>Delete Group</h4>,
							<div className='text-center'>
								<button className='btn btn-danger' onClick={this.deleteGroup}>
									Delete Group
								</button>
							</div>
						</TabPane>
					)}
				</TabContent>
			</div>
		);
	}
}

export default withRouter(
	ReduxConnect(GroupSettingsModal, {
		feed: 'feed',
		users: 'users',
		user: 'user',
	})
);
